import Slider from "../components/Slider";
import Video from '../components/Video';

const Gallery = () => {
    return ( 
        <>
        
  <header className="header">
  <h1 style={{ color: 'white' }}>Discover Tamil Nadu with Your Whole Heart</h1>
  <p>
    Explore the enchanting landscapes of Tamil Nadu by lying down amidst the
    serene beauty of nature. Witness the tall grass and the trickling streams,
    and let the buzz of the vibrant ecosystem captivate you. From the
    historical temples to the lush wildlife, Tamil Nadu offers a rich tapestry
    of experiences that invite you to connect deeply with the earth.
  </p>
</header>

  <div className="gal">
    <div className="gallery-category">
      <h2 className="gallery-title">Spirituals</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img
            src="/images/alagar-kovil-1656162510_8c9dad4870cf75c56674.webp"
            alt="Alagar Kovil"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/brihadeeswara-temple-1654763464_bfe471b31611964a6a2c.webp"
            alt="Brihadeeswara Temple"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/st-marys-cathedral-madurai-1657276043_1ad6ac33ce8884056999.webp"
            alt="Pilgrim Centres"
          />
        </div>
        <div className="gallery-item" style={{ marginLeft: "8%" }}>
          <img src="/images/sprit.webp" alt="Spiritual Image" />
        </div>
        <div className="gallery-item">
          <img
            src="/images/airavatesvara-temple-1654590765_dd8d125353da21a9b645.webp"
            alt="Airavatesvara Temple"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/thanjavur-1654770546_1a4fa1c088b5a3e91c74.webp"
            alt="Thanjavur"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/alagar-kovil-1656162510_8c9dad4870cf75c56674.webp"
            alt="Thanjavur"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/sri-renganatha-swamy-temple-srirangam-1656311253_7641e7ac3d3a947b1c26.webp"
            alt="Thanjavur"
          />
        </div>
      </div>
    </div>
    <div className="gallery-category">
      <h2 className="gallery-title">Nature</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img
            src="/images/ooty-1655457424_bca80f81e8391ebdaaca.webp"
            alt="Ooty"
          />
        </div>
        <div className="gallery-item">
          <img src="/images/season.webp" alt="Season" />
        </div>
        <div className="gallery-item">
          <img
            src="/images/waterfalls-1655142703_c9bb5f0fe1eb890f6a76.webp"
            alt="Waterfalls"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/pichavaram-1657806568_0d280b5f92dc337bc53a.webp"
            alt="Pichavaram"
          />
        </div>
      </div>
    </div>
    <div className="gallery-category">
      <h2 className="gallery-title">Heritage</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img
            src="/images/world-heritage-sites-1655143670_a557d11ac840b3cde674.webp"
            alt="World Heritage Sites"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/padmanabhapuram-palace-1656252445_8cbe61cc4095e2382601.webp"
            alt="Padmanabhapuram Palace"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/palaces-1655143260_215be284dbb80b6725f7.webp"
            alt="Palaces"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/padmanabhapuram-palace-1656252547_31ed9b142ded0a8b22b1.webp"
            alt="Rameswaram"
          />
        </div>
      </div>
    </div>
    <div className="gallery-category">
      <h2 className="gallery-title">Wildlife</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img src="/images/w1.jpg" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img src="/images/w3.jpg" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img src="/images/w4.webp" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img src="/images/w5.webp" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img src="/images/w2.jpg" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img src="/images/wild.jpeg" alt="Wild Image" />
        </div>
        <div className="gallery-item">
          <img
            src="/images/wildlife-1655142647_42a29910ad254ba4440d.webp"
            alt="Wildlife"
          />
        </div>
      </div>
    </div>
    <div className="gallery-category">
      <h2 className="gallery-title">Adventures</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img src="/images/festival.webp" alt="Festival" />
        </div>
        <div className="gallery-item">
          <img src="/images/train.webp" alt="Train" />
        </div>
        <div className="gallery-item">
          <img
            src="/images/pamban-bridge-1657626900_807115d4ec289b1376cd.webp"
            alt="Car Adventure"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/rameswaram-1657003415_923d56f8f2fe1ac0f94a.webp"
            alt="Rameswaram"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/dharmapuri-1654194392_6e3e3cdfdd3337059dd5.webp"
            alt="Dharmapuri"
          />
        </div>
      </div>
    </div>
    <div className="gallery-category">
      <h2 className="gallery-title">Beaches</h2>
      <div className="gallery">
        <div className="gallery-item">
          <img src="/images/t.webp" alt="Thanjavur" />
        </div>
        <div className="gallery-item">
          <img
            src="/images/dhanushkodi-1657617190_a01160e4f134648aa6de.webp"
            alt="Chembarambakkam Tank"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/rameswaram-1657461832_79c34f9c9aa78af777bc.webp"
            alt="Rameswaram Beach"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/kanyakumari-1654195435_bab3b5c9e1fc90ab56a8.webp"
            alt="Rameswaram Beach"
          />
        </div>
        <div className="gallery-item">
          <img
            src="/images/rameswaram-1657461832_79c34f9c9aa78af777bc.webp"
            alt="Thanjavur"
          />
        </div>
      </div>
    </div>
  </div>
  {/*testimonial*/}
  <div
    className="py-5"
    style={{
      backgroundImage:
        "url(/images/pamban-bridge-1657626900_807115d4ec289b1376cd.webp)",
      backgroundPosition: "right bottom",
      backgroundSize: "cover",
      backgroundRepeat: "repeat",
      backgroundAttachment: "fixed",
      marginTop: "1%"
    }}
  >
    <div className="container">
      <div className="row">
        <div className="ml-auto p-3 col-md-2 bg-white">
          {" "}
          <img
            className="img-fluid d-block rounded-circle"
            src="/images/Screenshot 2024-07-26 011017.png"
          />{" "}
        </div>
        <div className="p-3 col-md-7 mr-auto bg-white text-dark">
          <div className="blockquote mb-0">
            <p>
              "A wonderful serenity has taken possession of my entire soul, like
              these sweet mornings of spring which I enjoy with my whole heart.
              I am alone, and feel the charm of existence in this spot, which
              was created for the bliss of souls like mine."
            </p>
            <div className="blockquote-footer">
              {" "}
              <b>vignesh</b>, CEO at connectour.
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <Video />
    <Slider />
  
</>

     );
}
 
export default Gallery;